// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "share-api-polyfill") return "javascripts/" + chunkId + ".7268047ec2.js";
	if (chunkId === "tobii") return "javascripts/" + chunkId + ".0902cd1c50.js";
	if (chunkId === "create-popper") return "javascripts/" + chunkId + ".a4e96ad7b1.js";
	if (chunkId === "use-input-limits") return "javascripts/" + chunkId + ".4a71fe7fb6.js";
	if (chunkId === "use-intl-tel-input") return "javascripts/" + chunkId + ".71c52048bd.js";
	if (chunkId === "use-pell") return "javascripts/" + chunkId + ".67474d5d15.js";
	if (chunkId === "use-tags") return "javascripts/" + chunkId + ".287a0fbac3.js";
	if (chunkId === "use-typeahead") return "javascripts/" + chunkId + ".c0eed69eff.js";
	if (chunkId === "autocompleter") return "javascripts/" + chunkId + ".89049e8b60.js";
	if (chunkId === "use-richtext") return "javascripts/" + chunkId + ".b3e59b4b97.js";
	// return url for filenames based on template
	return undefined;
};